<template>
    <div class="right" >
        <el-button @click="dateActive(index)" v-for="(item ,index) in date" :class="['btn',{'active':active == index}]" 
        :key="index">{{item.tit}}</el-button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            date:[
                {tit:'近7天'},
                {tit:'近15天'},
                {tit:'近30天'}
            ],
            active:2
        }
    },
    methods:{
        //右上角日期选择
        dateActive(index){
            // console.log(index);
            this.active = index;
            this.$emit('onDate', index)
        }
    }
}
</script>

<style scoped lang="scss">
.right {
    padding: 8px 2px;
    color: #999;
    cursor: pointer;
    .btn{
        width: 60px;
    }
    .active{
        color: #FE4D45;
        background: #FFF4F4;
        border:1px solid #FE4D45
    }
}
</style>